<template>
    <div class="modal__wrapper modal__wrapper--search">
        <span class="modal-close modal-close-icon">
            <ModalClose />
        </span>
        <swiper ref="swiper" @swiper="handleSwiperInit" :allowTouchMove="false">
            <swiper-slide :key="1">
                <modal-tire-search ref="tire_search" @clear-search-history="clearSearchHistory"
                    @build-history="buildHistoryLabel" :is-loading="isLoading"
                    :user-selected-data.sync="userSelectedData" @setIsLoading="setIsLoading"
                    @on-finalized="handleFinalResultClick" @show-postal-code-form="showPostalCodeForm" />

            </swiper-slide>
            <swiper-slide :key="2">
                <modal-postal-code :is-loading="isLoading" @setIsLoading="setIsLoading"
                    @send-postal-code="receivePostal" />
            </swiper-slide>
        </swiper>

        <div v-if="isLoading" class="full-spinner">
            <VueSpinnerTail size="100" color="white" />
        </div>
    </div>
</template>

<script>
import axios from "axios";
// Main Components
import ModalClose from "./modalClose";
import ModalTireSearch from "./modalTireSearch";
import ModalPostalCode from "./modalPostalCode";
// Slider
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';

// Helpers
import { getCookie, generateCookieExpiry, deleteCookiesByName } from "../scripts/helpers"

import { VueSpinnerTail } from "vue3-spinners";
import { toRaw } from 'vue';
export default {
    data() {
        return {
            currentSlide: 1,
            swiper: "", // Needs to declared on mount
            tireSearchUrl:
                externalAPIEndpoint + '/tires',
            userSelectedData: {
                vehicle: {},
                vehicle_trim: {}, // inconsistent snake case to match type string from API
                tire_size: {},
                loadSpeedRating: {},
                categories: []
            },
            // This is for the Homepage, which will refer to these values so that
            // when a user clicks them - they will be sent to the shop-tires page along with
            // along the arguments.
            searchHistory: [],
            searchHistoryData: {
                label: '', // string,
                query: ''
            },
            firstItemTypes: [
                'vehicle',
                'tire_size',
                // 'tire_brand',
                // 'tire_model'
            ],
            postal: '',
            city: '',
            province: '',
            showMap: false,
            modalMode: '',
            isLoading: false
        };
    },
    components: {
        ModalClose,
        ModalTireSearch,
        Swiper, SwiperSlide,
        ModalPostalCode,
        VueSpinnerTail
    },
    methods: {
        setIsLoading(data) {
            this.isLoading = data
        },
        receivePostal(postalCode) {
            this.isLoading = true
            this.postal = postalCode;
            this.city = getCookie('city');
            this.province = getCookie('province');
            // Unset 
            deleteCookiesByName('postal');
            // 1 year
            document.cookie = `postal=${postalCode}; expires=${generateCookieExpiry()}; path=/`
            if (this.modalMode === 'postal') {
                const newURL = new URL(window.location.href);
                const newSearchParams = new URLSearchParams(window.location.search);
                newSearchParams.set('postal', this.postal)
                newSearchParams.set('city', this.city)
                newSearchParams.set('province', this.province)
                newSearchParams.set('search_id', this.generateUniqueID())
                newURL.search = newSearchParams
                window.location.href = newURL
            } else {
                this.handleRedirect()
            }
        },

        handleSwiperInit(swiper) {
            this.swiper = swiper;
        },

        /**
         * Since the modalTireSearch component handles the checking if a vehicle matches, we need to do
         * catch that data here.
         * @param {Boolean} data
         * @returns null
         */
        handleVehicleMatch(data) {
            this.vehicleMatches = data;
        },
        // WIP - need to check if a user hasn't set a postal code yet
        showPostalCodeForm() {
            this.carouselDom.next();
        },

        /**
         * We need to save the data selected from the Modal the URL so that the WordPress page
         * can use these as a reference
         */
        saveSelectedParamsToURL(searchID) {
            let searchParams = {
                search_id: searchID,
                postal: this.postal,
                city: this.city,
                province: this.province
            };

            Object.entries(this.userSelectedData).forEach(
                ([paramKey, paramGroup]) => {
                    if (
                        (!this.userSelectedData.tire_brand &&
                            !this.userSelectedData.tire_model) &&
                        paramKey === "vehicle" &&
                        !Object.values(paramGroup).length
                    ) {

                        searchParams = {
                            ...searchParams,
                            ...this.includePreviousVehicleData(),
                        };

                    } else {
                        Object.entries(paramGroup).forEach(([key, val]) => {
                            searchParams[key] = typeof val === 'object' ? JSON.stringify(val) : val;
                        });
                    }
                }
            );
            const url = new URL(this.tireSearchUrl);
            url.search = new URLSearchParams(searchParams);
            if (this.userSelectedData.categories) {
                url.search = url.search + '&categories=' + JSON.stringify(this.userSelectedData.categories)
            }
            return url;
        },

        /**
         * Main handler for when a user clicks the the final result that would supposedly take them to the
         * main Tire Search Page
         * @param {Object} item
         */
        async handleFinalResultClick() {
            // const getPostal = 
            this.postal = getCookie('postal')
            this.city = getCookie('city')
            this.province = getCookie('province')
            if (this.modalMode === 'update-vehicle') {
                this.updateUserVehiclePreferences()
            }
            else if (this.modalMode === 'update-rear-tire') {
                this.updateRearTire()
            }
            else if (this.modalMode === 'update-front-tire') {
                this.updateFrontTire()
            }
            else if (this.postal && this.city && this.province) {
                this.isLoading = true
                this.handleRedirect()
            }
            else {
                this.swiper.slideTo(1)
            }

        },

        handleRedirect() {
            const searchID = this.generateUniqueID();
            const finalSearchParams =
                this.saveSelectedParamsToURL(searchID).search;
            const finalUrl = "/shop-tires" + finalSearchParams
            this.saveHistoryItem(finalUrl)
            this.saveSearchHistoryAsCookie()

            window.location.href = finalUrl;
        },

        saveSelectedData(item) {
            this.userSelectedData[item.type] = item.data;
        },

        /**
         * The ID is supposed to be used as a reference on the shop-tires page access the data
         * saved by this search.
         * @returns String
         */
        generateUniqueID() {
            return Math.random().toString(36).substr(2, 20);
        },

        logCookies() {
            const theCookies = document.cookie.split(";");
            let aString = "";
            for (var i = 1; i <= theCookies.length; i++) {
                // console.log(theCookies[i - 1])
                aString += i + " " + theCookies[i - 1] + "\n";
            }
        },

        includePreviousVehicleData() {
            const searchParams = (new URL(document.location)).searchParams;
            const searchParamsObj = {
                vYear: searchParams.get('vYear'),
                vMake: searchParams.get('vMake'),
                vModel: searchParams.get('vModel'),
                vTrim: searchParams.get('vTrim')
            }
            let areValuesValid = true;
            Object.values(searchParamsObj).forEach(val => {
                if (!val) {
                    areValuesValid = false
                    return;
                }
            })

            if (!areValuesValid) {
                return {}
            }

            else {
                return searchParamsObj
            }

        },


        // History Related Functions
        clearSearchHistory() {
            this.searchHistoryData.label = ''
            this.searchHistoryData.query = ''
        },

        buildHistoryLabel(item) {
            if (!this.searchHistoryData.label) {
                this.searchHistoryData.label = item.value
            } else {
                this.searchHistoryData.label += " " + item.value
            }
        },

        saveHistoryItem(str) {
            this.searchHistoryData.query = str
            if (this.searchHistory.length >= 2) {
                // remove first item because the last item in the array
                // is their latest search.
                this.searchHistory.shift()
            }
            this.searchHistory.push(this.searchHistoryData)
        },

        /**
         * This data will be used in the front-page.php file to display suggested search results.
         */
        saveSearchHistoryAsCookie() {
            let historyData = toRaw(this.searchHistory)
            const cookieName = 'tireSearchHistory'
            deleteCookiesByName(cookieName)
            const historyDataCookie = btoa(JSON.stringify(historyData))
            document.cookie = `${cookieName}=${historyDataCookie}; expires=${generateCookieExpiry()}; path=/`;
        },

        getSavedSearchHistory() {
            const cookieName = 'tireSearchHistory'
            const tireSearchCookie = getCookie(cookieName)
            let tireSearchHistory = ''
            try {
                tireSearchHistory = JSON.parse(atob(tireSearchCookie))
                this.searchHistory = tireSearchHistory
            } catch (error) {
                deleteCookiesByName(cookieName)
                console.log('error fetching search history')
            }
        },

        /**
         * Updates user's metadata in the WP DB to have preferred vehicles.
         */
        updateUserVehiclePreferences() {
            this.isLoading = true
            axios
                .post("/wp-json/account/vehicles/v1/add", {
                    vehicle: this.userSelectedData.vehicle
                }, {
                    // Needed to get logged in user's ID
                    headers: {
                        'X-WP-Nonce': this.wpNonce
                    }
                })
                // Show results regardless of error updating  vehicle
                .finally(() => {
                    const vehicleData = this.userSelectedData.vehicle
                    const newURL = new URL(window.location.href);
                    const newSearchParams = new URLSearchParams(window.location.search);
                    newSearchParams.set('vMake', vehicleData.vMake)
                    newSearchParams.set('vModel', vehicleData.vModel)
                    newSearchParams.set('vTrim', vehicleData.vTrim)
                    newSearchParams.set('vYear', vehicleData.vYear)
                    newSearchParams.set('search_id', this.generateUniqueID())
                    newURL.search = newSearchParams
                    window.location.href = newURL
                })
            // send to WP api
        },

        updateRearTire() {

            this.isLoading = true
            const newURL = new URL(window.location.href);
            const newSearchParams = new URLSearchParams(window.location.search);
            const rearSizes = this.userSelectedData.tire_size
            newSearchParams.set('rtWidth', rearSizes.tWidth)
            newSearchParams.set('rtDiameter', rearSizes.tDiameter)
            newSearchParams.set('rtFormat', rearSizes.tFormat)
            newSearchParams.set('rtRatio', rearSizes.tRatio)
            newSearchParams.set('rtRim', rearSizes.tRim)
            newSearchParams.set('rtLoadSpeed', this.userSelectedData.loadSpeedRating.tLoadSpeed)
            newSearchParams.set('tireToggle', 'rear')

            if (rearSizes.tFormat === 'flotation') {
                newSearchParams.delete('rtRatio')
            } else {
                newSearchParams.delete('rtDiameter')
            }

            //new search id to reset compare data
            newSearchParams.set('search_id', this.generateUniqueID())
            newURL.search = newSearchParams
            window.location.href = newURL
        },


        updateFrontTire() {
            this.isLoading = true
            const newURL = new URL(window.location.href);
            const newSearchParams = new URLSearchParams(window.location.search);
            const frontSizes = this.userSelectedData.tire_size
            newSearchParams.set('tDiameter', frontSizes.tDiameter)
            newSearchParams.set('tWidth', frontSizes.tWidth)
            newSearchParams.set('tFormat', frontSizes.tFormat)
            newSearchParams.set('tRatio', frontSizes.tRatio)
            newSearchParams.set('tRim', frontSizes.tRim)
            newSearchParams.set('tLoadSpeed', this.userSelectedData.loadSpeedRating.tLoadSpeed)
            newSearchParams.set('tireToggle', 'front')

            if (frontSizes.tFormat === 'flotation') {
                newSearchParams.delete('tRatio')
            } else {
                newSearchParams.delete('tDiameter')
            }

            //new search id to reset compare data
            newSearchParams.set('search_id', this.generateUniqueID())
            newURL.search = newSearchParams
            window.location.href = newURL
        }
    },
    mounted() {
        this.getSavedSearchHistory()
        window.addEventListener("set-modal-mode", (event) => {
            if (event.detail === 'postal') {
                this.modalMode = 'postal'
                this.swiper.slideTo(1)
            } else if (event.detail === 'update-vehicle') {
                this.modalMode = 'update-vehicle';
            } else if (event.detail === 'update-rear-tire') {
                this.modalMode = 'update-rear-tire';
            }
            else if (event.detail === 'update-front-tire') {
                this.modalMode = 'update-front-tire';
            }
            else {
                this.modalMode = '';
                this.swiper.slideTo(0)
            }
        });

        window.addEventListener('set-wp-nonce', event => {
            // Needed to get logged in user's ID
            this.wpNonce = event.detail
        })
    },
};
</script>
